import { Injectable } from '@angular/core';
import { catchError, timeout } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ControlCentreApiClient, PatientLocationDTO, ReferringDoctorDTO } from 'src/app/api-module/control-centre-api-client';

const HTTP_TIMEOUT_MSECONDS = 15000;

@Injectable({
    providedIn: 'root'
})
export class AutocompleteService {
    constructor(private controlCentreApiClient: ControlCentreApiClient) {}

    getReferringDoctors(siteId: number): Observable<ReferringDoctorDTO[]> {
        if (!siteId) {
            return of([]);
        }

        return this.controlCentreApiClient
            .autoComplete_GetReferringDoctors(siteId)
            .pipe(timeout(HTTP_TIMEOUT_MSECONDS))
            .pipe(catchError(_error => of([]))); // Don't make error visible to user
    }

    getPatientLocations(siteId: number): Observable<PatientLocationDTO[]> {
        if (!siteId) {
            return of([]);
        }
        return this.controlCentreApiClient
            .autoComplete_GetPatientLocations(siteId)
            .pipe(timeout(HTTP_TIMEOUT_MSECONDS))
            .pipe(catchError(_error => of([]))); // Don't make error visible to user
    }
}
